import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHourglass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M3.75 1.75h12.5m0 16.5H3.75m2 0v-2.469a2 2 0 0 1 .264-.992l2.169-3.797a2 2 0 0 0 0-1.984L6.013 5.21a2 2 0 0 1-.263-.992V1.75m8.5 16.5v-2.469a2 2 0 0 0-.264-.992l-2.169-3.797a2 2 0 0 1 0-1.984l2.17-3.797a2 2 0 0 0 .263-.992V1.75"
	})]
});
const ForwardRef = forwardRef(SvgHourglass);
export { ForwardRef as ReactComponent };
